import { phoneAuthAdminQueryKeys as e } from "./phoneAuthAdminQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPhoneAuthApi as n } from "@maat/api-main";
//#region src/phoneAuth/admin/usePhoneAuthTransactionQuery.ts
var r = (r) => t({
	queryKey: e.transaction(r ?? ""),
	queryFn: () => n.getTransaction(r),
	enabled: !!r
});
//#endregion
export { r as usePhoneAuthTransactionQuery };
